module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "styleClass": "vgt-table condensed",
      "pagination-options": {
        enabled: true,
        perPage: 10,
        perPageDropdown: [10, 20, 30],
      },
      "search-options": {
        enabled: true,
        trigger: 'enter',
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'plan_name') ? _c('span', [_vm._v("\n                  " + _vm._s(_vm.planName(props.row.plan)) + "\n                ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'plan_amt') ? _c('span', [_vm._v("\n                  " + _vm._s(_vm.planAmt(props.row.plan)) + "\n                ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'DisbursementDate') ? _c('span', [_vm._v("\n                  " + _vm._s(_vm._f("myDate")(props.row.disbursementDate)) + "\n                ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'EmiStartDate') ? _c('span', [_vm._v("\n                  " + _vm._s(_vm._f("myDate")(props.row.emiStartDate)) + "\n                ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'EmiEndDate') ? _c('span', [_vm._v("\n                  " + _vm._s(_vm._f("myDate")(props.row.emiEndDate)) + "\n                ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'collection_Center') ? _c('span', [(props.row.collection_center) ? _c('button', {
          staticClass: "btn btn-xs btn-info",
          on: {
            "click": function($event) {
              return _vm.viewGroupMember(props.row.collection_center.id)
            }
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.collection_center.name) + "\n                  ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (props.column.field == 'Status') ? _c('span', [(props.row.status == 'pending') ? _c('span', {
          staticClass: "label label-warning"
        }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (props.row.status == 'disbursed') ? _c('span', {
          staticClass: "label label-success"
        }, [_vm._v("Disbursed")]) : _vm._e()]) : _c('span', [_vm._v("\n                  " + _vm._s(props.formattedRow[props.column.field]) + "\n                ")])]
      }
    }])
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Recent Loan Disbursed")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e6f3a6ea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dashboard/recentdisbursment.vue
// module id = 910
// module chunks = 0